const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/cotizador"],
    exact: true,
    component: "Cotizador",
  },
  {
    // Página OCULTA de pruebas del cotizador de Cabitrans One (2026-10-14):
    // noindex, Disallow en robots.txt y sin enlaces. Clave de PRUEBAS de One.
    path: ["/cotizador-one"],
    exact: true,
    component: "CotizadorPruebas",
  },
  {
    // Destino del enlace del correo de presupuesto:
    // /solicitud-cliente?ref=PLM…  El cliente ve su presupuesto y lo acepta.
    // Antes lo servía un HTML suelto en httpdocs/solicitud-cliente/; desde el
    // 2026-07-28 es una pantalla nativa de esta web. Ese directorio ya NO debe
    // existir en el docroot: taparía esta ruta (y con la regla -d del .htaccess
    // Apache acaba devolviendo el 500 de Passenger).
    path: ["/solicitud-cliente"],
    exact: true,
    component: "SolicitudCliente",
  },
  {
    path: ["/payment/success"],
    exact: true,
    component: "Payment/Success",
  },
  {
    path: ["/payment/failure"],
    exact: true,
    component: "Payment/Failure",
  },
  {
    path: ["/aviso-legal"],
    exact: true,
    component: "Legal/AvisoLegal",
  },
  {
    path: ["/politica-de-privacidad"],
    exact: true,
    component: "Legal/Privacidad",
  },
  {
    path: ["/cookies"],
    exact: true,
    component: "Legal/Cookies",
  },
  {
    path: ["/servicios/:slug"],
    exact: true,
    component: "Service",
  },
  {
    path: ["/servicios/:slug/:city"],
    exact: true,
    component: "Service",
  },
  {
    path: ["/ciudades/:city"],
    exact: true,
    component: "City",
  },
];

export default routes;
